import fillCrudMetadataGaps, { PartialField } from '../../fillCrudMetadataGaps';
import authorization from '../../util/authorization';
import client from '../client';
import { currencies } from '../currencyExchangeRule';
const masterBuyerFields: PartialField[] = [{
  custom_groupName: 'Master Buyer',
  label: 'ID na omnibees',
  name: 'omniId',
  type: 'text',
  insertable: true,
  render: false
}, {
  custom_groupName: 'Master Buyer',
  label: 'Tipo',
  name: 'crmProfileType',
  type: 'text',
  options: [{
    label: 'Agência',
    value: 'travelAgent'
  }, {
    label: 'Empresa',
    value: 'corporate'
  }
  //{ label: 'Agência (Posto)', value: 'travelAgency' }, // No momento não iremos permitir cadastrar posto.
  ],
  inputType: 'select',
  custom_showInCreateMasterBuyer: true,
  custom_showInUpdateMasterBuyer: true,
  custom_readOnlyInCreateMasterBuyer: false,
  custom_readOnlyInUpdateMasterBuyer: true,
  custom_requiredMasterBuyer: true
}, {
  deprecated: true,
  render: false,
  hint: 'ID da agência que este posto está vinculado na omnibees',
  custom_groupName: 'Master Buyer',
  label: 'ID da agência pai',
  name: 'parentAgentId',
  type: 'text'
}, {
  render: entity => entity?.crmProfileType === 'travelAgency' ? entity?.parentAgent?.render : false,
  hint: 'Agência que este posto está vinculado na omnibees',
  custom_groupName: 'Master Buyer',
  label: 'Agência pai',
  name: 'parentAgent',
  type: 'object',
  inputType: 'inputOmnibeesBuyerAutoComplete',
  fields: [{
    name: 'id',
    label: 'ID',
    type: 'text'
  }, {
    name: 'name',
    label: 'Nome',
    type: 'text'
  }],
  insertable: true,
  custom_showInCreateMasterBuyer: true,
  custom_showInUpdateMasterBuyer: true,
  custom_readOnlyInUpdateMasterBuyer: true
}, {
  render: false,
  custom_groupName: 'Master Buyer',
  label: 'Tpi type',
  name: 'tpiType',
  type: 'int',
  insertable: true,
  options: [{
    label: 'Agência',
    value: 1
  }, {
    label: 'Agência (Posto)',
    value: 3
  }],
  inputType: 'select',
  custom_showInCreateMasterBuyer: false,
  custom_showInUpdateMasterBuyer: false,
  custom_readOnlyInUpdateMasterBuyer: true
}, {
  custom_groupName: 'Master Buyer',
  label: 'PCC',
  name: 'code',
  required: true,
  type: 'text',
  insertable: true,
  custom_showInCreateMasterBuyer: true,
  custom_showInUpdateMasterBuyer: true,
  custom_readOnlyInCreateMasterBuyer: false,
  custom_readOnlyInUpdateMasterBuyer: false
}, {
  custom_groupName: 'Master Buyer',
  label: 'Linguagem',
  name: 'language',
  type: 'text',
  insertable: true,
  custom_showInCreateMasterBuyer: true,
  custom_showInUpdateMasterBuyer: false,
  custom_readOnlyInUpdateMasterBuyer: true,
  required: true,
  // Opções de valores esperadas pelo backend
  options: [{
    label: 'Br',
    value: 'br'
  }, {
    label: 'Pt',
    value: 'pt'
  }, {
    label: 'Es',
    value: 'es'
  }, {
    label: 'En',
    value: 'en'
  }, {
    label: 'Fr',
    value: 'fr'
  }, {
    label: 'Da',
    value: 'da'
  }, {
    label: 'It',
    value: 'it'
  }, {
    label: 'De',
    value: 'de'
  }],
  inputType: 'select'
}, {
  custom_groupName: 'Master Buyer',
  label: 'ID linguagem',
  name: 'languageId',
  type: 'text',
  insertable: true
}, {
  custom_groupName: 'Master Buyer',
  label: 'Moeda',
  name: 'currency',
  inputType: 'select',
  options: currencies,
  insertable: true,
  custom_showInCreateMasterBuyer: true,
  required: true
}, {
  custom_groupName: 'Master Buyer',
  label: 'ID moeda',
  name: 'currencyId',
  type: 'text',
  insertable: true
}, {
  custom_group: 'credential',
  custom_groupName: "Credencial",
  label: 'Apelido',
  name: 'credential_alias',
  type: 'text',
  custom_showInCreateMasterBuyer: true,
  custom_showInUpdateMasterBuyer: true,
  required: true,
  hint: 'Este campo será usado para preencher o apelido e a descrição na credencial'
}, {
  custom_group: 'credential',
  custom_groupName: "Credencial",
  label: 'Usuário da credencial',
  name: 'credential_crs_username',
  type: 'text',
  insertable: true,
  required: true,
  autoComplete: 'new-password',
  custom_showInCreateMasterBuyer: true,
  custom_showInUpdateMasterBuyer: true
}, {
  custom_group: 'credential',
  custom_groupName: "Credencial",
  label: 'Senha da credencial',
  name: 'credential_crs_password',
  type: 'text',
  insertable: true,
  custom_showInCreateMasterBuyer: true,
  custom_showInUpdateMasterBuyer: true,
  required: true,
  inputType: 'InputPassword'
}, {
  name: 'tenantClients',
  label: 'Clientes Implantados',
  type: 'objectarray',
  default: [],
  fields: [{
    name: 'tenantUrl',
    label: 'Instalação',
    type: 'text'
  }, {
    name: 'clientUrl',
    label: 'Cliente',
    type: 'text'
  }, {
    name: 'credentialUrl',
    label: 'Credencial',
    type: 'text'
  }, {
    name: 'clientId',
    label: 'clientId',
    type: 'text',
    render: false
  }, {
    name: 'credentialId',
    label: 'credentialId',
    type: 'text',
    render: false
  }, {
    name: 'tenantId',
    label: 'tenantId',
    type: 'text',
    render: false
  }, {
    name: 'tenantAlias',
    label: 'tenantAlias',
    type: 'text',
    render: false
  }, {
    name: 'tenantAliasReplaced',
    label: 'tenantAliasReplaced',
    type: 'text',
    render: false
  }, {
    name: 'tenantTenantId',
    label: 'tenantTenantId',
    type: 'text',
    render: false
  }],
  render(entity) {
    return entity?.tenantClients?.map(tenantClient => {
      const formattedTenantClient = `${tenantClient.tenantUrl}`;
      return formattedTenantClient;
    }).join('\n');
  }
}];
const fields = [...client.fields, ...masterBuyerFields];
export default fillCrudMetadataGaps({
  label: 'Master Buyer',
  labelPlural: 'Master Buyers',
  name: 'MasterBuyer',
  updatable: true,
  insertable: true,
  authorization: authorization('master', 'master'),
  // TODO mudar para superuser
  dynamoDB: {
    tableName: 'SpearMasterBuyer'
  },
  columns: ['id', 'omniId', 'brand_name', 'corporate_name', 'vat', 'code', 'crmProfileType'],
  fields,
  filter: [{
    name: 'brand_name_beginsWith',
    field: 'brand_name',
    op: 'beginsWith',
    label: 'Brand Name'
  }, {
    name: 'enabled_eq',
    field: 'enabled',
    op: 'eq',
    label: 'Ativo'
  }, {
    name: 'brand_name_contains',
    field: 'brand_name',
    op: 'contains',
    label: 'Brand Name'
  }, {
    name: 'vat_eq',
    field: 'vat',
    op: 'eq',
    label: 'CNPJ'
  }, {
    name: 'crmProfileType_in',
    field: 'crmProfileType',
    op: 'in',
    label: 'Tipo'
  }, {
    name: 'code_eq',
    field: 'code',
    op: 'eq',
    label: 'PCC'
  }, {
    name: 'corporate_name_contains',
    field: 'corporate_name',
    op: 'contains',
    label: 'Nome comercial'
  }]
});